import React, { Component } from "react";
import PropTypes from "prop-types";

export default class Popup extends Component {
  componentDidMount() {
    this.popup = window.open(
      "about:blank",
      "_blank",
      "resizable=yes, scrollbars=yes, titlebar=yes, width=600, height=500, top=10, left=10"
    );
    setTimeout(() => {
      this.popup.location.href = this.props.url;
      this.popup.resizeTo(
        this.props.width || 600,
        this.popup.window.outerHeight || 500
      );
    }, 10);

    this.closeTimer = setInterval(() => {
      if (this.popup.closed) {
        this.props.onClose();
        clearInterval(this.closeTimer);
      }
    }, 100);
  }

  componentWillUnmount() {
    this.popup.close();
  }

  componentWillReceiveProps() {
    setTimeout(() => {
      this.popup.location.href = this.props.url;
      this.popup.resizeTo(
        this.props.width || 600,
        this.popup.window.outerHeight || 500
      );
    }, 10);
  }

  render() {
    return <div />;
  }
}
